jQuery(document).ready(function () {
  // Delete that line if you don't want the first Div to be displayed by default
  $(".mobile-menu-heading").click(function () {
    $(this).next().slideToggle(500);
    $("div").not($(this).next()).slideUp(500);
    // how to rotate the icon JUST h3>i
    // $("i").css({'transform':'rotate(180deg)'});
  });

  $(".price-item--sale").each(function() {
    $(this).text($(this).text().replace("From", ""));
});

  // Header on mobile

  $(".header__icon--menu").click(function () {
    var wrap_index = $(".fullscreen-video-wrap");
    var overlay_index = $(".overlay");
    var videoBoxInfo_index = $(".videoBoxInfo");
    $(wrap_index).toggleClass("removeIndex");
    $(overlay_index).toggleClass("removeIndex");
    $(videoBoxInfo_index).toggleClass("removeIndex");
  });

  // Open Mega menu on hover

  $(".list-menu--inline li").hover(
    function () {
      $(".open-submenu", this).attr("open", "open");
      $(".open-submenu details", this).attr("open", "open");
    },
    function () {
      $(".open-submenu", this).removeAttr("open");
    }
  );

  // Back to Top Button

  $(window).scroll(function () {
    if ($(this).scrollTop() > 20) {
      $("#toTopBtn").show();
    } else {
      $("#toTopBtn").hide();
    }
  });

  $("#toTopBtn").click(function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      1000
    );
    return false;
  });

  $(window).scroll(function () {
    if (
      $(document).height() - $(window).height() - $(window).scrollTop() ==
      0
    ) {
      $("#toBottomBtn").fadeOut();
    } else {
      $("#toBottomBtn").fadeIn();
    }
  });

  $("#toBottomBtn").click(function () {
    $("html, body").animate(
      {
        scrollTop: $(document).height(),
      },
      1000
    );
    return false;
  });

  // Hijab style video Close button functionality

  $(".close-video").click(function () {
    $(this).hide();
    $(".video-img-section video").hide();
  });
  
  // Description Variants on Load

  // Find the checked input within the fieldset
  var checkedInput = $(".variant-options-1 input:checked");
  // Find the corresponding label
  var label = checkedInput.next("label");
  // Get the text content of the label
  var labelText = label.find("p").text();
  // Use the labelText as needed
  console.log("The label of the checked input is:", labelText);
  var labelWithoutChar = labelText.replace(/[^\w\s]/gi, "");
  labelWithoutChar = labelWithoutChar.replace(/\s+/g, "").toLowerCase();
  console.log("New Lowercase Swatch " + labelWithoutChar);
  $(
    ".product__info-wrapper .rte p, .product__info-wrapper .rte ul, .product__info-wrapper .rte h6"
  ).hide();
  $(".product__info-wrapper .rte h6").each(function () {
    var h6Text = $(this)
      .text()
      .replace(/[^\w\s]/gi, "")
      .toLowerCase();
    if (h6Text === labelWithoutChar) {
      var elementsToShow = $(this).nextUntil(".product__info-wrapper h6");
      elementsToShow.show();
    } else {
      console.log("No match found!");
    }
  });

  // Selected Swatch Description Populate

  $(document).on("click", ".product__info-wrapper label", function () {
    var getAttribute = $("p", this).text();
    var attrWithoutChar = getAttribute.replace(/[^\w\s]/gi, "");
    attrWithoutChar = attrWithoutChar.replace(/\s+/g, "").toLowerCase();
    console.log("New Lowercase Swatch " + attrWithoutChar);

    $(
      ".product__info-wrapper .rte p, .product__info-wrapper .rte ul, .product__info-wrapper .rte h6"
    ).hide();
    $(".product__info-wrapper .rte h6").each(function () {
      var h6Text = $(this)
        .text()
        .replace(/[^\w\s]/gi, "")
        .toLowerCase();
      if (h6Text === attrWithoutChar) {
        var elementsToShow = $(this).nextUntil("h6");
        elementsToShow.show();
      } else {
        console.log("No match found!");
      }
    });
  });

  // Populate relevant Variant Images

  $(document).on("click", ".product__info-wrapper label", function () {
    $(this)
      .closest(".product__info-wrapper")
      .find("label")
      .removeClass("active-swatch");
    $(this).addClass("active-swatch");
    var getAttribute = $("p", this).text();
    var attrWithoutChar = getAttribute.replace(/[^\w\s]/gi, "");
    console.log("Without Character " + attrWithoutChar);
    attrWithoutChar = attrWithoutChar.replace(/\s+/g, "-").toLowerCase();
    console.log("Lowercase " + attrWithoutChar);
    var clickedVariantName = "#style_" + attrWithoutChar;
    var productImages = $(".thumbnail-list__item");
    for (var i = 0; i < productImages.length; i++) {
      var dataGroup = $(productImages[i]).attr("thumbnail-color");
      var getVariantAttr = dataGroup ? dataGroup.toLowerCase() : "";
      if (getVariantAttr === clickedVariantName) {
        $(productImages[i]).show();
      } else {
        $(productImages[i]).hide();
      }
    }
  });

  // Display Swatch images for each Swatch

  // Get the labels
  var labelImages = $(".custom-variant .variant-bck-image");

  // Get the images
  var images = $(".variant-custom-images img");

  // Loop through each label and set the background image
  labelImages.each(function (index) {
    var imageUrl = $(images[index]).attr("src");
    $(this).css("background-image", "url(" + imageUrl + ")");
  });

  // Swatch Border

  $(".custom-variant").click(function () {
    $(".custom-variant").removeClass("active-swatch");
    $(this).addClass("active-swatch");
  });

  // Swatch Name on Form Label

  $(".custom-variant").click(function () {
    var getLabel = $("p", this).text();
    $(".variant-options-1 .form__label").text("Choose Style: " + getLabel);
  });

  // Swatch Name on Load function as a Label

  var findAttr = $(".variant-options-1").find("input[type='radio']:checked");
  if (findAttr) {
    var getLabelText = $(findAttr).next().children("p").text();
    $(".variant-options-1 .form__label").text("Choose Style: " + getLabelText);
  } else {
    console.log("Nahi Hai");
  }

  // Country Selector Pop Up

  // window.onload = function () {
  //   $(".bts-popup").delay(1000).addClass("is-visible");
  // };

  //open popup
  $(".bts-popup-trigger").on("click", function (event) {
    event.preventDefault();
    $(".bts-popup").addClass("is-visible");
    $(".bts-popup-trigger").addClass("popup-visible");
  });

  //close popup
  $(".bts-popup").on("click", function (event) {
    if (
      $(event.target).is(".bts-popup-close") ||
      $(event.target).is(".bts-popup")
    ) {
      event.preventDefault();
      $(this).removeClass("is-visible");
      $(".bts-popup-trigger").removeClass("popup-visible");
    }
  });
  //close popup when clicking the esc keyboard button
  // $(document).keyup(function (event) {
  //   if (event.which == "27") {
  //     $(".bts-popup").removeClass("is-visible");
  //   }
  // });

  // Redirect user as per Selected Location

  $(".bts-popup-button").click(function () {
    var storeLocation = $("#storeDropdown").find(":selected").val();
    console.log(storeLocation);
    window.location.href = storeLocation;
  });

  // Submenu styling

  var selectedParent = $(".nav-collection_image")
    .parent()
    .parent()
    .parent()
    .addClass("active-submenu");
  console.log(selectedParent);

  var selectedGrandParent = $(".nav-collection_image")
    .parent()
    .parent()
    .parent()
    .parent()
    .addClass("active-parent-submenu");
  console.log(selectedGrandParent);

  // $(document).on("click", ".swatch-view-item", function () {
  //   setTimeout(() => {
  //     console.log("Variant Clicked:");
  //     $(".product__media-item").removeAttr("style");
  //     $(".product__media-item").removeClass("product__media-item--variant");
  //     var thumbnail = $(".thumbnail-list__item");
  //     var thumbnailColor = thumbnail.attr("thumbnail-color");
  //     if (thumbnailColor === "") {
  //       thumbnail.removeAttr("style");
  //     }
  //   }, "1000");
  // });

  // Disable the Recently Viewed Products Link

  $(".recently-viewed-grid-item a").attr(
    "style",
    "cursor: not-allowed; pointer-events: none;"
  );
  $(window).scroll(function () {
    var scrollPosition = $(window).scrollTop();
    if (scrollPosition > 500) {
      // The screen has been scrolled from the top 500 pixels
      console.log("Screen scrolled from the top 500 pixels.");
      $(".recently-viewed-grid-item a").attr(
        "style",
        "cursor: pointer; pointer-events: pointer;"
      );

      // Add your desired code or actions here
    } else {
      $(".recently-viewed-grid-item a").attr(
        "style",
        "cursor: not-allowed; pointer-events: none;"
      );
    }
  });

  // Fetch Specific Product Details

    //   $(".color-swatch").click(function () {
    //   let selectedStyle = $(".filter-title", this).text();
    //   selectedStyle = selectedStyle.toLowerCase().replace(/\s+/g, '-');
    //   var collectionHandle = $("#collectionTitle").val();
    //   console.log("Variant Style " + selectedStyle);
    //   console.log("Collection Handle " + collectionHandle);
    //   var counter = 0;
    //     $.ajax({
    //     url: '/collections/' + collectionHandle + '/' + selectedStyle + '?view=product-style-filter',
    //     type: 'GET',
    //     success: function(data) {
    //       // Assuming data is returned in HTML format with products
    //       let productList = $(data).find('.grid-product');
  
    //       productList.each(function() {
    //         let product = $(this);
    //         let price = product.find('.grid-product__price').text();
    //         let productUrl = product.find('a').attr('href');
    //         console.log("Counter " + counter++);
    //         console.log('Price:', price);
    //         console.log('Product URL:', productUrl);
    //       });
    //     },
    //     error: function() {
    //       console.error('Error fetching products.');
    //     }
    //   });
    // });
});

// Header menus link replacement

// jQuery(document).ready(function ($) {
//   var selectedItem = $("#Details-HeaderMenu-2 .active-submenu li:last-child p");
//   console.log(selectedItem);
//   selectedItem.hide();
//   $("#Details-HeaderMenu-2 .active-submenu li:last-child a").attr(
//     "href",
//     "https://www.bokitta.pk/pages/the-complete-hijab-design-style-guide"
//   );
// });

var selectedParent1 = $("#Details-HeaderMenu-2 .nav-collection_image").next();
var selectedParent2 = $("#Details-HeaderMenu-2 .nav-collection_image")
  .next()
  .next();
selectedParent1.hide();
selectedParent2.hide();
$("#Details-HeaderMenu-2 .nav-collection_image")
  .parent()
  .attr("href", "/pages/the-complete-hijab-design-style-guide");

// Header menus link replacement End